// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "mobile-menu") return "module.mobile-menu.ecd07193.js";
	if (chunkId === "component-accordion") return "module.component-accordion.a49fe035.js";
	if (chunkId === "component-cookie-button") return "module.component-cookie-button.c17128f4.js";
	if (chunkId === "component-copy") return "module.component-copy.786ef2a4.js";
	if (chunkId === "component-drawer-button") return "module.component-drawer-button.e1925dd7.js";
	if (chunkId === "component-address-form") return "module.component-address-form.3b46befa.js";
	if (chunkId === "resources_js_utils_format-money_ts") return "module.resources_js_utils_format-money_ts.ae86a8b8.js";
	if (chunkId === "component-cart-drawer") return "module.component-cart-drawer.f5c9988e.js";
	if (chunkId === "component-lazy-content") return "module.component-lazy-content.a2cefc31.js";
	if (chunkId === "component-responsive-video") return "module.component-responsive-video.132d600a.js";
	if (chunkId === "component-slider") return "module.component-slider.18746c8e.js";
	if (chunkId === "component-tabs") return "module.component-tabs.5aaf15ae.js";
	if (chunkId === "component-terms-alert") return "module.component-terms-alert.5502ef1d.js";
	if (chunkId === "component-text-sections-with-images") return "module.component-text-sections-with-images.ca35f821.js";
	if (chunkId === "404") return "module.404.c38280b5.js";
	if (chunkId === "blog") return "module.blog.297dc223.js";
	if (chunkId === "collection-products") return "module.collection-products.ad35bdce.js";
	if (chunkId === "collection-seo") return "module.collection-seo.58320ad0.js";
	if (chunkId === "designers") return "module.designers.8d5a2ad9.js";
	if (chunkId === "gift-card-form") return "module.gift-card-form.177d814b.js";
	if (chunkId === "product") return "module.product.29e655c4.js";
	if (chunkId === "product-media") return "module.product-media.296be969.js";
	if (chunkId === "node_modules_pnpm_core-js_3_48_0_node_modules_core-js_modules_es_set_js") return "module.pnpm_core-js_3_48_0_core-js_modules_es_set_js.3a6b809b.js";
	if (chunkId === "product-form") return "module.product-form.63fcf565.js";
	if (chunkId === "product-configurator") return "module.product-configurator.c12c149e.js";
	if (chunkId === "product-specs-list") return "module.product-specs-list.7b556b0b.js";
	if (chunkId === "search-page") return "module.search-page.27df22ae.js";
	if (chunkId === "focus-trap") return "module.focus-trap.5d0bac09.js";
	if (chunkId === "string-memory") return "module.string-memory.260c8349.js";
	// return url for filenames based on template
	return undefined;
};